module.exports = __webpack_public_path__ + "img/v2_menu_burger.4235b59b.svg";